import { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { CardContainer, CardWithModal, TitleAndEditButton } from 'shared-components';

import { ApplicationState } from '../../../../../store';
import { saveVisaPrepForm } from '../../../../../store/student/actions';
import { createUpdateVPIFieldAction } from '../../../../../store/student/visaPrepForm/actions';
import QuestionPage from '../../../../templates/question';
import { VQ } from '../../../../../store/student/types';
import LeaveToRemains from './leaveToRemains';
import { ILeaveToRemain } from '../../../../../types';
import { Pages } from '../../../../../store/student/visaPrepForm/types';
import { getPageStatus } from './utils';
import { useNavigate } from 'react-router-dom';
import { useCustomNavigate } from '../../../../../hooks/useCustomNavigate';

const VisaPrepFormAddHistoryPage5 = (props: any) => {
  // dispatch actions
  const dispatch = useDispatch();

  const onNext = () => {
    dispatch(saveVisaPrepForm(Pages.PAGE2_5));
  };

  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(createUpdateVPIFieldAction(fieldName, value, refValue));

  const navigate = useNavigate();
  const onBackToTaskList = () => navigate(-1);

  const { navigateTo } = useCustomNavigate();
  const onEdit = () => navigateTo(`${props.params.offerId}/history/step-2`);

  // state props from store
  const defaultArr = useMemo(() => {
    return [];
  }, []);
  const leaveToRemains =
    useSelector(({ student }: ApplicationState) => student.visa.leaveToRemains, shallowEqual) || defaultArr;

  // constants
  const currentStep = 5;
  const steps = 8;

  // component state
  const [complete, setComplete] = useState(false);
  const [leaveToRemainsState, setLeaveToRemainsState] = useState<ILeaveToRemain[]>([]);
  const [showModal, setShowModal] = useState<boolean[]>([]);

  useEffect(() => {
    setLeaveToRemainsState([
      ...leaveToRemains,
      {
        applicationDate: '',
        applicationType: '',
        reference: '',
      },
    ]);
    setShowModal([...leaveToRemains.map(_ => false), false]);
  }, [leaveToRemains]);

  useEffect(() => {
    const { complete: newComplete } = getPageStatus({
      leaveToRemains,
    });
    if (newComplete !== complete) {
      setComplete(newComplete);
    }
  }, [complete, leaveToRemains]);

  const toggleModal = (index: number) => {
    setShowModal(showModal.map((value, i) => (i === index ? !value : value)));
  };

  const deleteLeave = (index: number): void => {
    onChange(VQ.LEAVE_TO_REMAINS, [...leaveToRemains.slice(0, index), ...leaveToRemains.slice(index + 1)]);
  };

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onNext={onNext}
      onBackToTaskList={onBackToTaskList}
      section={'Additional History'}
    >
      <TitleAndEditButton
        title="You indicated that you have previously applied for Leave to Remain in the UK"
        onClick={onEdit}
      />

      <CardContainer title={`How many times?`}>
        {leaveToRemainsState.map((leave: ILeaveToRemain, index: number) => (
          <CardWithModal
            key={index}
            id={`leave-to-remains-${index}`}
            index={index}
            modalTitle={'Add Leave to Remain'}
            cardItems={[
              {
                label: 'Date of application',
                value: leave.applicationDate,
              },
              {
                label: 'Type of application',
                value: leave.applicationType,
              },
              {
                label: 'Home office Reference Number',
                value: leave.reference,
              },
            ]}
            onRemove={deleteLeave}
            addButtonLabel={`Add Leave to Remain`}
            addAnotherButtonLabel={`I have another Leave to Remain to add`}
            hasAddMoreButton={leave.applicationDate === '' && leave.applicationType === '' && leave.reference === ''}
            showModal={showModal[index]}
            toggleModal={toggleModal}
          >
            <LeaveToRemains
              index={index}
              applicationDate={leave.applicationDate}
              applicationType={leave.applicationType}
              reference={leave.reference}
              onSaveAndClose={(leave: ILeaveToRemain) => {
                const leaves = [...leaveToRemains];
                leaves[index] = {
                  ...leave,
                };
                onChange(VQ.LEAVE_TO_REMAINS, leaves);
                toggleModal(index);
              }}
            />
          </CardWithModal>
        ))}
      </CardContainer>
    </QuestionPage>
  );
};
export default VisaPrepFormAddHistoryPage5;
